import { render } from "./clubBook.vue?vue&type=template&id=4a8dcaa5"
import script from "./clubBook.vue?vue&type=script&lang=js"
export * from "./clubBook.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__